const isMobileNumber = number => {
  const len = number.length
  return (len === 10 || len === 11) && number.match(/^01/)
}

export default isMobileNumber
